<!--
 * @Author: zl
 * @Date: 2022-12-13 17:35:53
 * @LastEditTime: 2022-12-29 17:17:00
 * @LastEditors: zl
 * @Description: 数据角色权限弹窗--直接配置/条件配置
-->
<template>
	<div class='Dialog-role-layout'>
		<el-dialog :close-on-click-modal="false"
				   center
				   :title="dialogTitle"
				   :visible.sync="dialogShow"
				   width="1200px"
				   custom-class="dataRoleDialog"
				   :before-close="dialogClose"
				   top="10vh"
				   :destroy-on-close="true">
			<template v-if="dialogType == 'directly'">
				<div class="primary-layout"
					 style="height:500px;padding: 20px 0;">
					<div class='primary-header'>
						<div class='left-text'>合计项目: {{ totalNum }} 条</div>
						<div class='btnGroups'>
							<el-input v-model="searchForm.sname"
									  size="small"
									  placeholder="请输入项目名称"
									  clearable
									  class="custom-input-inner ml10">
								<el-button class="btn-success"
										   size="small"
										   slot="append"
										   @click="submitForm">查询</el-button>
							</el-input>

							<!-- 弹出框搜素区域 -->
							<el-popover placement="bottom-end"
										width="415"
										trigger="click">
								<el-form ref="searchForm"
										 :model="searchForm"
										 size="small"
										 label-width="140px">
									<el-form-item label="建设单位项目负责人"
												  prop="unitLinkerIds">
										<el-select v-model="searchForm.unitLinkerIds"
												   placeholder="请选择"
												   multiple
												   clearable>
											<el-option v-for="(item, index) in jsPersonList"
													   :key="index"
													   :label="item.sname"
													   :value="item.id"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="项目类型"
												  prop="proType">
										<el-select v-model="searchForm.proType"
												   placeholder="请选择"
												   clearable>
											<el-option v-for="item in projectDict.dxxmlx"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="建设类型"
												  prop="constructionType">
										<el-select v-model="searchForm.constructionType"
												   placeholder="请选择"
												   clearable>
											<el-option v-for="item in projectDict.dxjslx"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="项目归属区域"
												  prop="isNorth">
										<el-select placeholder="请选择"
												   v-model="searchForm.isNorth"
												   size="small">
											<el-option v-for="item in projectDict.xmgsqy"
													   :key="item.id"
													   :value="item.value"
													   :label="item.sname"></el-option>
										</el-select>
									</el-form-item>
									<el-form-item label-width="0"
												  class="text-center borderTop">
										<el-button type="primary"
												   icon="el-icon-search"
												   @click="submitForm">查询</el-button>
										<el-button icon="el-icon-refresh"
												   @click="resetForm">重置</el-button>
									</el-form-item>
								</el-form>
								<el-button type="success"
										   size="small"
										   slot="reference"
										   icon="el-icon-arrow-down"
										   class="ml10 mr10 btn-success"></el-button>
							</el-popover>
							<el-button icon="el-icon-menu"
									   type="primary"
									   size="small"
									   @click="doFilter">列过滤</el-button>
						</div>
					</div>
					<div class='primary-content w-table-layout mt10'>
						<div class='w-table-content'>
							<vxe-table align="center"
									   border
									   :data="directly.data"
									   height="100%"
									   highlight-hover-row
									   highlight-current-row
									   :loading="directly.loading"
									   ref="directlyTable"
									   show-overflow="tooltip"
									   show-header-overflow="tooltip"
									   :checkbox-config="{ trigger: 'row' }">
								<vxe-column type="checkbox"
											width="60"></vxe-column>
								<vxe-column type="seq"
											title="序号"
											width="60"></vxe-column>
								<vxe-column field="sname"
											title="项目名称"
											header-align="center"
											align="left"
											min-width="200"></vxe-column>
								<vxe-column field="proNo"
											title="项目编号"
											:visible="false"
											width="160"></vxe-column>
								<vxe-column field="shortName"
											title="建设单位"
											header-align="center"
											align="left"
											width="140">
									<template #default="{ row }">
										<el-tooltip :content="row.tenantName"
													placement="top"
													effect="dark">
											<span>{{ row.shortName }}</span>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column field="userName"
											title="建设单位项目负责人"
											width="160"></vxe-column>
								<vxe-column field="newProTypeName"
											title="项目类型"
											width="120"></vxe-column>
								<vxe-column field="constructionTypeName"
											title="建设类型"
											width="120"></vxe-column>
								<vxe-column field="isNorthName"
											title="项目归属区域"
											width="110"></vxe-column>
								<vxe-column field="proTotalValue"
											title="项目总投资(万元)"
											width="130"
											header-align="center"
											align="right"></vxe-column>
								<vxe-column field="planStartTime"
											title="计划开竣工时间"
											width="190">
									<template #default="{ row }">
										<span v-if="row.planStartTime">
											{{ row.planStartTime.substring(0, 10) }}
										</span>
										<span v-if="row.planEndTime">
											到 {{ row.planEndTime.substring(0, 10) }}
										</span>
									</template>
								</vxe-column>
							</vxe-table>
						</div>
					</div>
				</div>
			</template>
			<template v-if="dialogType == 'conditions'">
				<div v-loading="contentLoding">
					<el-row class="border-bottom">
						<el-col :span="16"
								:offset="4"
								class="step-box">
							<div v-for="item in stepList"
								 :key="item.active + 'step'"
								 :class="{'active': item.active <= activeStep }"
								 class="step-bar">
								<div class="circle">{{ item.active }}</div>
								<div class="label">{{ item.label }}</div>
								<div v-if="item.line"
									 class="line"></div>
							</div>
						</el-col>
					</el-row>
					<template v-if="activeStep == 1">
						<el-row class="table-box">
							<el-col :span="8">
								<p>配置条件</p>
								<vxe-table align="center"
										   border
										   :data="step1.data"
										   highlight-hover-row
										   highlight-current-row
										   height="400px"
										   :loading="step1.loading"
										   ref="conditionsLeftTable"
										   show-overflow="tooltip"
										   show-header-overflow="tooltip"
										   @current-change="currentChange"
										   @checkbox-change="checkboxLeftChange"
										   @checkbox-all="checkboxLeftAll"
										   :row-config="{ keyField: 'id' }">
									<vxe-column type="checkbox"
												width="70"></vxe-column>
									<vxe-column type="seq"
												width="70"
												title="序号"></vxe-column>
									<vxe-column title="条件名称"
												field="sname"></vxe-column>
								</vxe-table>
							</el-col>
							<el-col :span="16">
								<p>请选择需要查看条件下的单项</p>
								<div class="step-header"
									 v-if="currentRow.id == '10086002'">
									<div class="left-text">共{{ step1.rightData.length }}个单位</div>
									<div class="btnGroups">
										<el-input v-model="searchForm.sname"
												  size="small"
												  placeholder="请输入单位名称"
												  clearable
												  class="custom-input-inner ml10">
											<el-button class="btn-success"
													   size="small"
													   slot="append"
													   @click="searchUnit(searchForm.sname)">查询</el-button>
										</el-input>
										<el-button type="success"
												   class="btn-success ml10"
												   size="small"
												   icon="el-icon-refresh"
												   @click="searchUnit('')"></el-button>
									</div>
								</div>
								<vxe-table align="center"
										   border
										   :data="step1.rightData"
										   highlight-hover-row
										   highlight-current-row
										   :height="currentRow.id == '10086002' ? '358px' : '400px'"
										   :loading="step1.rightLoading"
										   ref="conditionsRightTable"
										   show-overflow="tooltip"
										   show-header-overflow="tooltip"
										   @checkbox-change="checkboxRightChange"
										   @checkbox-all="checkboxRightAll"
										   :row-config="{ keyField: 'id' }">
									<vxe-column type="checkbox"
												width="70"></vxe-column>
									<vxe-column type="seq"
												width="70"
												title="序号"></vxe-column>
									<vxe-column title="项目归属区域"
												field="sname"
												v-if="currentRow.id == '10086001'"></vxe-column>
									<template v-if="currentRow.id == '10086002'">
										<vxe-column title="单位类型"
													field="limitName"></vxe-column>
										<vxe-column title="单位名称"
													field="sname"
													header-align="center"
													align="left"></vxe-column>
									</template>
									<vxe-column title="项目类型"
												field="sname"
												v-if="currentRow.id == '10086003'"></vxe-column>
									<vxe-column title="建设类型"
												field="sname"
												v-if="currentRow.id == '10086004'"></vxe-column>
								</vxe-table>
							</el-col>
						</el-row>
					</template>
					<template v-if="[2, 3].includes(activeStep)">
						<div v-if="activeStep == 2"
							 class="tips">
							<i class="el-icon-info"></i>
							<div>
								<p>根据前面配置条件，选择该条件之间的项目关系。如前面选择了条件，则需确定是取条件之间的交集项目还是并集项目。</p>
								<p>其按照前后顺序计算且或。例如：当选择条件一且条件二或条件三，则计算（条件一且条件二）或条件三。</p>
							</div>
						</div>
						<div v-if="activeStep == 3"
							 class="tips-3">
							该条件配置下项目列表
						</div>
						<vxe-table align="center"
								   border
								   class="mb20 mt20"
								   :data="activeStep == 2 ? conditions.data : conditions.projectData"
								   highlight-hover-row
								   highlight-current-row
								   height="400px"
								   :loading="conditions.loading"
								   ref="conditionsTable"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip">
							<template v-if="activeStep == 2">
								<vxe-colgroup v-for="item in conditions.data"
											  :key="item.id + 'table1'"
											  :title="item.sname"
											  header-class-name="custom-table-height"
											  width="1150px">
									<vxe-column v-for="(n, index) in item.children"
												:key="n.id + 'table2' + index"
												:field="n.field"
												:title="n.noTitle ? '' : customTitle(n, index)"
												header-class-name="custom-table-height">
										<template #default="{ row }">
											<template v-if="!n.noTitle">
												{{ n[n.field] }}
											</template>
											<template v-else>
												<el-radio-group v-model="n.roleConten">
													<el-radio label="and">且</el-radio>
													<el-radio label="or">或</el-radio>
												</el-radio-group>
											</template>
										</template>
									</vxe-column>
								</vxe-colgroup>
							</template>
							<template v-if="activeStep == 3">
								<vxe-column type="seq"
											width="60"
											title="序号"></vxe-column>
								<vxe-column title="项目名称"
											min-width="300px"
											field="sname"
											align="left"
											header-align="center"></vxe-column>
								<vxe-column title="建设单位"
											width="150px"
											field="shortName"
											header-align="center"
											align="left">
									<template #default="{ row }">
										<el-tooltip :content="row.tenantName"
													placement="top"
													effect="dark">
											<span>{{ row.shortName }}</span>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column title="建设单位项目负责人"
											width="150px"
											field="userName"></vxe-column>
								<vxe-column title="项目类型"
											width="150px"
											field="newProTypeName"></vxe-column>
								<vxe-column title="项目归属区域"
											width="150px"
											field="isNorthName"></vxe-column>
								<vxe-column title="建设类型"
											width="150px"
											field="constructionTypeName"></vxe-column>
							</template>
						</vxe-table>
					</template>
				</div>
			</template>
			<span slot="footer">
				<template v-if="dialogType == 'conditions'">
					<el-button size="small"
							   class="btn"
							   @click="handleClick('back')"
							   v-if="activeStep != 1">返回上一级</el-button>
					<el-button type="primary"
							   size="small"
							   class="btn"
							   :loading="btnLoading"
							   @click="handleClick('next')"
							   v-if="activeStep != 3">确定选择</el-button>
				</template>
				<el-button type="primary"
						   size="small"
						   class="btn"
						   :loading="btnLoading"
						   @click="dialogSubmit"
						   v-if="showBtn()">确定生效</el-button>
			</span>
		</el-dialog>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getTreeTableList } from '@/api/system/sysTenant'
import * as API from '@/api/system/DataRole'
import ColumnFilter from '@/views/Common/ColumnFilter'
export default {
	props: {
		dialogType: {
			type: String,
			default: '',
		},
		roleId: {
			type: String,
			default: '',
		},
	},
	components: { ColumnFilter },
	data() {
		return {
			dialogTitle: '选择项目配置查看权限',
			dialogShow: false,
			totalNum: 0, //合计项目
			// 列过滤对象数组
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			searchForm: {
				sname: '', //工程项目名称
				unitLinkerIds: [], //建设单位项目负责人
				proType: '', //项目类型
				constructionType: '', //建设类型
				isNorth: '', //项目归属区域
				roleId: '', //数据角色
			},
			jsPersonList: [], //建设单位项目负责人
			directly: {
				data: [],
				loading: false,
			},
			conditions: {
				data: [],
				projectData: [],
				loading: false,
			},
			btnLoading: false,
			activeStep: 1,
			roleLimit: [], //主体单位
			originList: [], //基础数据
			step1: {
				data: [],
				loading: false,
				rightData: [],
				rightLoading: false,
			},
			currentRow: {},
			areaIds: '', //项目归属区域ids
			unitIds: '', //单位ids
			proTypeIds: '', //项目类型ids
			constructionTypeIds: '', //建设类型ids
			historyData: [], //生效的规则
			contentLoding: false,
			conditionsObj: {
				A: 'areaIds',
				B: 'unitIds',
				C: 'proTypeIds',
				D: 'constructionTypeIds',
			},
			stepBox: {
				A: 0,
				B: 1,
				C: 2,
				D: 3,
			},
		}
	},
	created() {
		// 查询用于配置的项目
		if (this.dialogType == 'directly') {
			this.getProjectList()
			// 获取项目建设单位负责人
			this.getProjectUser()
			return
		}
		this.contentLoding = true
		// 获取主体列表
		this.getTreeTableList()
	},
	mounted() {
		if (this.dialogType != 'directly') {
			setTimeout(() => {
				this.step1.data = this.optionList
				let obj = this.step1.data[0]
				this.step1.rightData = obj.data
				this.currentRow = this.$utils.clone(obj, true)
				this.$refs.conditionsLeftTable.setCurrentRow(obj, true)
				// 获取保存生效的规则
				this.getConfigCondit()
			}, 600)
		}
	},
	methods: {
		/**********   准备工作   **********/
		// 打开弹窗
		open() {
			this.dialogShow = true
		},

		// 查询用于配置的项目
		getProjectList() {
			let params = this.$utils.clone(this.searchForm, true)
			params.roleId = this.roleId
			if (params.unitLinkerIds.length > 0) {
				params.unitLinkerIds = params.unitLinkerIds.join(',')
			} else {
				params.unitLinkerIds = ''
			}
			this.directly.loading = true
			API.getProjectList(params)
				.then((res) => {
					this.directly.data = res.data
					this.totalNum = res.data.length
					this.directly.loading = false
					res.data.map((x) => {
						if (x.isChecked == '1') {
							setTimeout(() => {
								this.$refs.directlyTable.setCheckboxRow(x, true)
							}, 200)
						}
					})
				})
				.catch(() => {
					this.directly.loading = false
				})
		},

		// 获取项目建设单位负责人
		getProjectUser() {
			API.getProjectUser({}).then((res) => {
				this.jsPersonList = res.data
			})
		},

		// 获取主体列表
		getTreeTableList() {
			getTreeTableList({}).then((res) => {
				this.roleLimit = res.data
				this.originList = this.$utils.clone(res.data, true)
			})
		},

		// 条件配置获取项目接口
		getProjectByConfigCondit() {
			let configCondit = this.$utils.clone(
				this.conditions.data[0].children,
				true
			)
			this.conditions.loading = true
			API.getProjectByConfigCondit({
				configCondit,
			})
				.then((res) => {
					this.conditions.loading = false
					this.conditions.projectData = res.data
				})
				.catch(() => {
					this.conditions.loading = false
				})
		},

		// 获取保存生效的规则
		getConfigCondit() {
			let tableData = this.step1.data
			API.getConfigCondit({ roleId: this.roleId })
				.then((res) => {
					this.historyData = this.$utils.clone(res.data, true)
					if (res.data.length > 0) {
						res.data.map((x) => {
							setTimeout(() => {
								let refs = this.$refs.conditionsLeftTable
								// 用 roleType 获取对应参数字段，再将对应值赋予到参数字段内
								let field = this.conditionsObj[x.roleType]
								this[field] = x.roleConten
								// 再将参数有值的对应行复选框进行勾选
								if (x.roleType != 'E') {
									let index = this.stepBox[x.roleType]
									refs.setCheckboxRow(tableData[index], true)
								}
								this.currentChange({ row: this.currentRow })
								this.contentLoding = false
							}, 200)
						})
						return
					}
					this.contentLoding = false
				})
				.catch(() => {
					this.contentLoding = false
				})
		},

		// 控制按钮展示
		showBtn() {
			if (this.dialogType == 'directly') {
				return true
			}
			return this.activeStep == 3 ? true : false
		},

		/**********   列过滤   **********/

		// 点击列过滤
		doFilter() {
			// 列过滤对象数组
			let tableShowColumn = this.$refs.directlyTable.getTableColumn()
			let collectColumn = tableShowColumn.collectColumn
			collectColumn.shift()
			collectColumn.shift()
			this.$set(this.filterColumns[0], 'columns', collectColumn)
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			if (this.$refs.directlyTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.directlyTable.refreshColumn()
				this.getProjectList()
			}
		},

		/**********   条件查询   **********/

		// 表单搜索
		submitForm() {
			this.getProjectList()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.sname = ''
			this.getProjectList()
		},

		/**********   条件配置表格操作   **********/

		// 查询
		searchUnit(name) {
			let sname = name.trim()
			this.step1.rightData = this.originList.filter((x) =>
				x.sname.includes(sname)
			)
		},

		// 行点击事件
		currentChange({ row }) {
			// 取出当前行里的单项列表数据
			this.step1.rightData = this.$utils.clone(row.data, true)
			this.currentRow = this.$utils.clone(row, true)
			// 先获取到当前行的参数名字
			let type = this.currentRow.id != '10086002' ? 'value' : 'id'
			let field = this.conditionsObj[row.roleType]
			// 然后右侧单项的 id 或者 value 已经在参数内
			if (this[field] && this[field] != '') {
				this.step1.rightData.map((x) => {
					if (this[field].includes(x[type])) {
						// 将勾选复选框
						this.$refs.conditionsRightTable.setCheckboxRow(x, true)
					}
				})
			}
			if (row.id != '10086002') {
				this.searchForm.sname = ''
			}
		},

		// 行点击事件 右侧 单选
		checkboxLeftChange({ row, checked }) {
			// 选中/取消的多选框，先将当前行选中，并取出对应右侧的内容
			this.step1.data.map((x) => {
				if (row.id == x.id) {
					this.$refs.conditionsLeftTable.setCurrentRow(x, true)
					this.currentRow = this.$utils.clone(row, true)
					this.step1.rightData = x.data
					setTimeout(() => {
						// 左侧单选右侧单项全选
						this.step1.rightData.map((x) => {
							this.$refs.conditionsRightTable.setCheckboxRow(
								x,
								checked
							)
						})
						this.checkboxRightAll()
					}, 200)
				}
			})
		},

		// 行点击事件 左侧 全选
		checkboxLeftAll({ records }) {
			if (records.length > 0) {
				records.map((x) => {
					// 全选将所有的单项的值都取出来放进对应参数内
					let field = this.conditionsObj[x.roleType]
					let type = field == 'unitIds' ? 'id' : 'value'
					this[field] = x.data.map((x) => x[type]).join(',')
				})
				this.currentChange({ row: this.currentRow })
			} else {
				// 此处为全部取消，将参数清空，全选取消
				this.areaIds = ''
				this.unitIds = ''
				this.proTypeIds = ''
				this.constructionTypeIds = ''
				this.step1.rightData.map((x) => {
					this.$refs.conditionsRightTable.setCheckboxRow(x, false)
				})
			}
		},

		// 行点击事件 右侧 单选
		checkboxRightChange({ row }) {
			this.computedIds()
		},

		// checkall 右侧 全选
		checkboxRightAll() {
			this.computedIds()
		},

		// 计算id
		computedIds() {
			// 获取右侧所有的勾选中的行
			let checkArr = this.$refs.conditionsRightTable.getCheckboxRecords()
			let ids,
				values = ''
			// 有选中的了将id 和 value 取出来逗号分割
			if (checkArr.length > 0) {
				ids = checkArr.map((x) => x.id).join(',')
				values = checkArr.map((x) => x.value).join(',')
			}
			// 如果右侧选中了，那么左侧条件也勾选，反之则取消
			let state = checkArr.length > 0 ? true : false
			this.step1.data.map((x) => {
				if (x.id == this.currentRow.id) {
					this.$refs.conditionsLeftTable.setCheckboxRow(x, state)
				}
			})
			// 将取出来的值放进对应的四个参数内
			let field = this.conditionsObj[this.currentRow.roleType]
			this[field] = field == 'unitIds' ? ids : values
		},

		// 自定义标题
		customTitle(row, index) {
			let title = ''
			if (row.noTitle) {
				return title
			}
			let obj = {
				0: '一',
				2: '二',
				4: '三',
				6: '四',
			}
			return '条件' + obj[index]
		},

		/**********   操作按钮事件   **********/

		// 弹窗关闭/取消事件
		dialogClose() {
			this.dialogShow = false
			this.btnLoading = false
			this.$emit('closed')
		},

		// 点击
		handleClick(type) {
			if (type == 'back') {
				this.activeStep -= 1
				if (this.activeStep == 1) {
					// 返回到step 为1的时候 将左侧已经勾选的回显上在默认选中第一条
					this.$nextTick(() => {
						this.step1.data.map((x) => {
							if (x.checked) {
								this.$refs.conditionsLeftTable.setCheckboxRow(
									x,
									true
								)
							}
						})
						this.$refs.conditionsLeftTable.setCurrentRow(
							this.step1.data[0],
							true
						)
						this.currentChange({ row: this.step1.data[0] })
					})
				}
				return
			}
			if (this.activeStep == 1) {
				let arr = this.$refs.conditionsLeftTable.getCheckboxRecords()
				if (arr.length == 0) {
					this.$message.warning('至少勾选一项配置条件！')
					return
				}
				// 将勾选的checked 改为true方便返回上一步回显
				let ids = arr.map((x) => x.id)
				this.step1.data.map((x) => {
					this.$set(x, 'checked', ids.includes(x.id))
				})

				// 配置范围规则的要将勾选的展示出来
				let roleArr = this.$utils.clone(this.roleRule, true)
				roleArr[0].children.map((x) => {
					this.$set(x, 'show', ids.includes(x.id))
				})
				roleArr[0].children = roleArr[0].children.filter((x) => x.show)

				// 获取要展示的数组长度，往里面添加 且 和 或
				let length = roleArr[0].children.length
				if (length > 1) {
					let obj = {
						typeName5: '',
						id: '10086005',
						field: 'typeName5',
						roleType: 'E',
						roleConten: 'and',
						noTitle: true,
					}
					// 不同的长度往不同位置插入
					switch (length) {
						case 2:
							roleArr[0].children.splice(1, 0, obj)
							break
						case 3:
							roleArr[0].children.splice(1, 0, obj)
							roleArr[0].children.splice(3, 0, obj)
							break
						case 4:
							roleArr[0].children.splice(1, 0, obj)
							roleArr[0].children.splice(3, 0, obj)
							roleArr[0].children.splice(5, 0, obj)
							break
					}
				}
				this.conditions.data = this.$utils.clone(roleArr, true)

				// 如果这次确定选择 和 已经生效的配置一样那么将且 和 或 的关系也回显
				let hArr = []
				let pass = false
				// 只有在有保存生效的规则才判断回不回显
				if (this.historyData.length > 0) {
					// 获取保存生效的规则内的除了 roleType为E的数据
					hArr = this.historyData.filter((x) => x.roleType != 'E')
					// 先判断保存生效的和这次选中的程度是否一致
					if (hArr.length == length) {
						hArr.forEach((x) => {
							// 且勾选中的id 要和保存生效规则的id一样 pass 为true
							let field = this.conditionsObj[x.roleType]
							x.pass = x.roleConten == this[field] ? true : false
						})
						// 将pass为false 的过滤出来
						hArr = hArr.filter((x) => !x.pass)
						// 数组长度为0则 pass
						pass = hArr.length == 0 ? true : false
						// pass 的情况下将项目范围配置规则中的且 和 或的也回显上
						if (pass) {
							this.conditions.data[0].children.forEach(
								(x, index) => {
									if (x.roleType == 'E') {
										x.roleConten =
											this.historyData[index].roleConten
									}
								}
							)
						}
					}
				}
			}
			if (this.activeStep == 2) {
				this.getProjectByConfigCondit()
			}
			this.activeStep += 1
		},

		// 弹窗确定事件
		dialogSubmit() {
			// 直接配置
			if (this.dialogType == 'directly') {
				// 获取表格的复选框勾选项，至少勾选一条
				let checkArr = this.$refs.directlyTable.getCheckboxRecords()
				// if (checkArr.length == 0) {
				// 	this.$message.error('至少勾选一项！')
				// 	return
				// }
				// 参数
				let projectIds = checkArr.map((x) => x.id).join(',')
				let params = {
					roleId: this.roleId,
					projectIds,
				}
				this.btnLoading = true
				API.saveDirectConfigData(params)
					.then((res) => {
						this.$message.success('配置完成！')
						this.dialogClose()
					})
					.catch(() => {
						this.btnLoading = false
					})
				return
			}
			// 满足条件配置下的项目确认生效
			// 配置条件 删除id
			let configCondit = this.$utils.clone(
				this.conditions.data[0].children,
				true
			)
			configCondit.forEach((x) => {
				delete x.id
			})
			let params = {
				projectIds: this.conditions.projectData
					.map((x) => x.id)
					.join(','), //所有的项目id 逗号分割成字符串
				roleId: this.roleId, //当前角色id
				configCondit, //配置条件
			}
			this.btnLoading = true
			API.saveConfigCondit(params)
				.then((res) => {
					this.$message.success('配置完成！')
					this.dialogClose()
				})
				.catch(() => {
					this.btnLoading = false
				})
		},
	},
	computed: {
		// 码表
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		// 步骤条
		stepList() {
			let arr = [
				{
					active: 1,
					label: '请选择配置条件',
					line: true,
				},
				{
					active: 2,
					label: '请选择配置规则',
					line: true,
				},
				{
					active: 3,
					label: '确定配置生效',
					line: false,
				},
			]
			return arr
		},

		// 配置条件
		optionList() {
			let arr = [
				{
					sname: '项目归属区域',
					data: this.projectDict.xmgsqy,
					id: '10086001',
					checked: false,
					roleType: 'A',
				},
				{
					sname: '单位',
					data: this.roleLimit,
					id: '10086002',
					checked: false,
					roleType: 'B',
				},
				{
					sname: '项目类型',
					data: this.projectDict.dxxmlx,
					id: '10086003',
					checked: false,
					roleType: 'C',
				},
				{
					sname: '建设类型',
					data: this.projectDict.dxjslx,
					id: '10086004',
					checked: false,
					roleType: 'D',
				},
			]
			return arr
		},

		// 配置范围规则
		roleRule() {
			let arr = [
				{
					sname: '项目范围配置规则',
					id: '1000001',
					index: 1,
					children: [
						{
							typeName1: '项目归属区域',
							id: '10086001',
							field: 'typeName1',
							roleType: 'A',
							roleConten: this.areaIds,
						},
						{
							typeName2: '单位',
							id: '10086002',
							field: 'typeName2',
							roleType: 'B',
							roleConten: this.unitIds,
						},
						{
							typeName3: '项目类型',
							id: '10086003',
							field: 'typeName3',
							roleType: 'C',
							roleConten: this.proTypeIds,
						},
						{
							typeName4: '建设类型',
							id: '10086004',
							field: 'typeName4',
							roleType: 'D',
							roleConten: this.constructionTypeIds,
						},
					],
				},
			]
			return arr
		},
	},
}
</script>

<style lang='less' scoped>
.Dialog-role-layout {
	background-color: #fff;
}
.border-bottom {
	padding-top: 30px;
	padding-bottom: 20px;
	border-bottom: 2px dashed #eee;
}
.step-box {
	display: flex;
	align-items: center;
	justify-content: center;
	.step-bar {
		display: flex;
		align-items: center;
		user-select: none;
		.circle {
			width: 28px;
			height: 28px;
			line-height: 28px;
			border-radius: 50%;
			background-color: #cccccc;
			text-align: center;
			color: #fff;
			font-weight: bolder;
			margin-right: 10px;
		}
		.label {
			color: #666;
		}
		.line {
			width: 72px;
			height: 1px;
			margin: 0 10px;
			background-color: #ccc;
		}
	}
	.active {
		.circle {
			background-color: #58a3f7;
		}
		.label {
			color: #58a3f7;
		}
	}
}
.table-box {
	.el-col {
		padding: 20px 15px;
	}
	.el-col-8 {
		padding-left: 0px !important;
	}
	.el-col-16 {
		padding-right: 0px !important;
		padding-bottom: 0;
		border-left: 1px solid #eee;
	}
	p {
		font-weight: bolder;
		margin-bottom: 20px;
		font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
		color: #333;
	}
}
.step-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	.left-text {
		font-size: 14px;
		color: #202020;
	}
	.btnGroups {
		margin-left: 10px;
		display: flex;
		align-items: center;
	}
}
.tips {
	margin-top: 20px;
	background-color: #edf2fc;
	border: 1px solid #f2f2f2;
	color: #9c9399;
	padding: 15px 20px;
	display: flex;
	align-items: center;
	line-height: 20px;
	i {
		margin-right: 10px;
		font-size: 16px;
	}
}
.tips-3 {
	margin-top: 20px;
	color: #000;
	font-weight: bolder;
	font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
}
</style>

<style lang="less">
.vxe-table--tooltip-wrapper.theme--dark {
	z-index: 99999 !important;
}
.dataRoleDialog {
	.el-dialog__body {
		padding: 0 25px;
	}
}
</style>